import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Site from "@/site/Site";
import BlogPage from "@/site/BlogPage";
import BlogArticle from "@/site/BlogArticle";
import PlaybookPage from "@/site/PlaybookPage";
import AuditPage from "@/site/AuditPage";
import EbookPage from "@/site/EbookPage";
import AuditsOverview from "@/site/AuditsOverview";
import GAListener from "@/site/GAListener";
import ChatWidget from "@/site/ChatWidget";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <>
      <GAListener />
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.4, ease: [0.2, 0.7, 0.2, 1] }}
        >
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Site />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/playbook" element={<PlaybookPage />} />
            <Route path="/playbook/:slug" element={<EbookPage />} />
            <Route path="/linkedin-ads-playbook" element={<Navigate to="/playbook/linkedin-ads" replace />} />
            <Route path="/playbook/linkedin" element={<Navigate to="/playbook/linkedin-ads" replace />} />
            <Route path="/audits" element={<AuditsOverview />} />
            <Route path="/linkedin-ads-audit" element={<AuditPage platform="linkedin" />} />
            <Route path="/google-ads-audit" element={<AuditPage platform="google" />} />
            <Route path="/meta-ads-audit" element={<AuditPage platform="meta" />} />
            <Route path="/bing-ads-audit" element={<AuditPage platform="bing" />} />
            <Route path="*" element={<Site />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnimatedRoutes />
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}
